export default __webpack_public_path__ + "static/media/coin-profit.fa9eb085.wav";